import {formatAREAScore} from '../../../../services/util';
import { getUserData } from '../../../../services/API';

/*
* Given a score, metric, and scale, return a labeled score
*/
export function generateLabel(score, metric, scale, includeLabel=true) {

  // todo use enums
  let units = '';
  if(metric) {
    switch(metric) {
      case "ORF":
        units = generateORFLabel(scale, score);
        break;
      case "ReadingMastery":
        return formatAREAScore(score);
      case "SightRecognition":
        units = "%"
        break;
      case "PhonologicalAwareness":
        units = "%"
        break;
      case "VocabSize":
        units = " words"
        break;
      case "NWF":
        units = " correct"
      case "Spelling":
        units = " correct"
      case "ARM":
        units = " ARM"
      default:
        break;
        // code block
    }
  }

  if(units === "DRA") {
    return ("Level " + score);
  } else if (scale === "Lexile" && score < 0) {
    return Math.abs(score) + units;
  }

  if(metric === "VocabSize"){
    if (!includeLabel){
        return score;
    }
    return score + units;
  }

  if(metric == "ARM") {
    //For whatever reason, toFixed won't make a 0.0 so do it here (only for ARM, where 0.0 is a valid score)
    if(score == '0'){
      score = '0.0'
    }
    return score + units;
  }

  let precision = 3;
  if (score >= 1000 && score < 10000) {
    precision = 4;
  } else if (score >= 10000) {
    precision = 5;
  }

  let formattedScore = score.toPrecision(precision);
  if (!includeLabel) {
    return formattedScore;
  }
  return formattedScore + units;
}

function generateORFLabel(scale, score) {
  let units = '';
  if(scale) {
    switch(scale) {
      case "WCPM":
        units = " WCPM";
        break;
      case "Lexile":
        if(score > 0) {
          units = "L";
        } else {
          units = "BR";
        }
        break;
      case "DRA":
        units = "DRA";
    }
  }
  return units;
}

export default {
  generateLabel,
}